import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  signal,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDrawerMode } from '@angular/material/sidenav';
import { ICustomCategoryFund } from '@bp-core/src/lib/models/portal/goal/custom-category-fund.model';
import { ICustomPortfolioResult } from '@bp-core/src/lib/models/portal/goal/custom-portfolio-result.model';
import { ICustomFund } from '@bp-core/src/lib/models/portal/goal/fund-custom.model';
import { IGroupCategoryPercentage } from '@bp-core/src/lib/models/portal/goal/funding-percentages.model';
import { IStockBondsPercentage } from '@bp-core/src/lib/models/portal/goal/stock-bonds-percentages.model';
import {
  FinancialEntityModel,
  FundingModel,
  GoalModel,
  PortfolioCompositionModel,
  PortfolioModel,
  RiskLevelModel,
} from '@bp-core/src/lib/proto/common-message.pb';
import { BackService } from '@bp-core/src/lib/services/back.service';
import { GoalStateEnum } from 'bp/modules/goal/+xstate/goal-new/goal-new-machine.schema';
import { ICompositionGraph } from 'bp/shared/models/compositions-graph.model';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { INewCustomCategoryFund } from '@bp-core/src/lib/models/portal/goal/new-custom-category-fund.model';
import { INewCustomFund } from '@bp-core/src/lib/models/portal/goal/new-custom-fund.model';
import { BpConfirmationService } from 'bp/shared/services/bp-confirmation.service';
import { ColorService } from 'bp/shared/services/color.service';
import { GoalFundingService } from 'bp/shared/services/goal-funding.service';
import { UtilityService } from 'bp/shared/services/utility-service.service';
import { Subscription } from 'rxjs';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';
import { StickyClassDirective } from '../../directives/sticky-class.directive';
import { CustomPortfolioCardComponent } from '../custom-portfolio-card/custom-portfolio-card.component';
import { PortfolioCompositionGraphComponent } from '../portfolio-composition-graph/portfolio-composition-graph.component';

@Component({
  selector: 'app-goal-custom-portfolio',
  templateUrl: './goal-custom-portfolio.component.html',
  styleUrls: ['./goal-custom-portfolio.component.scss'],
  standalone: true,
  imports: [
    BpCoreModule,
    CustomPortfolioCardComponent,
    MatIconModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatDividerModule,
    MatButtonModule,
    StickyClassDirective,
    PortfolioCompositionGraphComponent,
  ],
})
export class GoalCustomPortfolioComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  StateEnum = GoalStateEnum;
  customFunds: INewCustomFund[];
  firstPartOfCategoryFunds: INewCustomCategoryFund[];
  secondPartOfCategoryFunds: INewCustomCategoryFund[];
  compositionsGraph: ICompositionGraph[];
  nationalInternationalPercentages = { nationalPercentage: 0, internationalPercentage: 0 };
  stockBondsPercentages: IStockBondsPercentage = { stockPercentage: 0, bondsPercentage: 0 };
  customPortfolioResult: ICustomPortfolioResult;
  isBottom: boolean;
  form: FormArray;
  compositionGraphTitle: string;
  subCategoryWithFundsLength: number;
  componentIsReady = false;
  title = 'Personaliza tu portafolio';
  subtitle =
    'Elegimos los mejores fondos para cada clase de activos. Ajusta los porcentajes; los cuales deben sumar 100%.';
  sumValue = 0;
  sum = 0;
  groupCategoryPercentages: IGroupCategoryPercentage[];
  riskLevel: RiskLevelModel;
  currentSubCategoryWithCustomFunds: INewCustomCategoryFund[] = [];
  sumSubscription: Subscription;
  mode: MatDrawerMode = 'side';

  @Input() isChangePortfolioFlow = false;
  @Input() showNonDefaultFundsButton = false;
  @Input() financialEntity: FinancialEntityModel;
  @Input() riskLevels: RiskLevelModel[];
  @Input() portfolio: PortfolioModel;
  @Input() goal: GoalModel;
  @Input() subCategoryWithCustomFunds: INewCustomCategoryFund[];
  @Output() next = new EventEmitter<ICustomPortfolioResult>();
  @Output()
  onChooseBpStrategyChange = new EventEmitter();
  @Input() currentCategoryFundAdded?: INewCustomCategoryFund;
  @Input() currentCategoryFundRemoved?: INewCustomCategoryFund;

  @Input() showNonDefaultFundsSignal = signal(false);

  @Output() onDeletedCustomFund = new EventEmitter<INewCustomCategoryFund>();
  @Output() onDestroy = new EventEmitter<void>();
  @Output() openFundDetail = new EventEmitter<FundingModel>();

  constructor(
    private fb: FormBuilder,
    private goalFundingService: GoalFundingService,
    public colorService: ColorService,
    private utilityService: UtilityService,
    private breakpointObserver: BreakpointObserver,
    private cd: ChangeDetectorRef,
    private backService: BackService,
    private bpConfirmationService: BpConfirmationService,
  ) {}
  ngOnDestroy(): void {
    this.onDestroy.emit();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.subCategoryWithCustomFunds?.currentValue) {
      // this.subCategoryWithCustomFunds = [...changes.subCategoryWithCustomFunds.currentValue];
      this.addCustomCategoryFund(changes.subCategoryWithCustomFunds.currentValue);
      this.componentIsReady = true;
    }
    // if (changes.currentCategoryFundRemoved?.currentValue) {
    //   this.utilityService.scrollSmoothly(
    //     `cg-new-goalCustomPortfolio-${
    //       this.currentCategoryFundRemoved!.customFunds[0].fund.fund?.mnemonic
    //     }-input`,
    //   );
    // }
  }
  ngOnInit(): void {
    this.utilityService.scrollToTopSmoothly();
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe(result => {
      if (result.matches) {
        this.mode = 'over';
      } else {
        this.backService.updateNoHeader(false);

        this.mode = 'side';
      }
    });

    // this.form = this.fb.array([]);
    // this.sumValue = 0;

    // this.subCategoryWithFundsLength = this.subCategoryWithCustomFunds!.length;
    // this.listenChanges();
    // this.getCustomFunds();
    this.componentIsReady = true;
    this.listenChanges();
  }

  addCustomCategoryFund(subCategoryWithCustomFunds: INewCustomCategoryFund[]) {
    let defaultCustomFunds = [...subCategoryWithCustomFunds];

    this.form = this.fb.array([]);
    // this.currentSubCategoryWithCustomFunds = [...subCategoryWithCustomFunds];
    this.currentSubCategoryWithCustomFunds = defaultCustomFunds.map(value => {
      return {
        category: value.category,
        customFunds: value.customFunds.map(f => {
          return {
            userPercentage: f.userPercentage,
            defaultPercentage: f.userPercentage,
            fund: f.fund,
            color: f.color,
            category: value.category,
            groupCategoryDisplayOrder: f.groupCategoryDisplayOrder,
          };
        }),
      };
    });
    this.getCustomFunds();
    this.subCategoryWithFundsLength = this.subCategoryWithCustomFunds!.length;
    this.listenChanges();
    if (this.currentCategoryFundAdded) {
      this.utilityService.scrollSmoothly(
        `cg-new-goalCustomPortfolio-${this.currentCategoryFundAdded.customFunds[0].fund?.mnemonic}-input`,
        2,
      );
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sumValue = this.sum;
    });
  }
  addCustomFundToCategory(customFunds: ICustomFund[], category: ICustomCategoryFund) {
    customFunds.forEach(fund => {
      const fundAdded = category.customFunds.find(f => f.fund.fund?.id === fund.fund.fund?.id);
      if (!fundAdded) category.customFunds.push(fund);
    });
  }
  onShowNonDefaultFundsChange() {
    if (!this.showNonDefaultFundsSignal()) {
      this.utilityService.scrollToTopSmoothly();
    }
    if (this.mode == 'over') this.backService.updateNoHeader(true);

    this.showNonDefaultFundsSignal.set(true);
  }
  onFundDeleteEvent(_event: INewCustomFund) {
    this.removeCustomFund(_event);

    this.onDeletedCustomFund.emit({
      customFunds: [_event],
      category: _event.category!,
    });
  }
  openHelpModal(template: any) {
    this.bpConfirmationService.open({
      title: 'Betterplan Top Funds',
      bodyTemplate: template,
    });
  }

  removeCustomFund(customFund: INewCustomFund) {
    this.form = this.fb.array([]);

    this.subCategoryWithCustomFunds = this.subCategoryWithCustomFunds
      .filter(value => {
        // Filtrar primero basado en la longitud del arreglo funds
        const funds = value.customFunds.filter(
          f => f.fund?.fundingId !== customFund.fund?.fundingId,
        );
        return funds.length > 0;
      })
      .map(value => {
        // Ahora mapear los valores filtrados
        return {
          category: value.category,
          customFunds: value.customFunds.filter(
            f => f.fund?.fundingId !== customFund.fund?.fundingId,
          ),
        };
      });

    this.getCustomFunds();
    this.subCategoryWithFundsLength = this.subCategoryWithCustomFunds!.length;
    this.listenChanges();
  }

  getCustomFunds() {
    let funds: INewCustomFund[] = [];
    let compositions: ICompositionGraph[] = [];
    let percentageAcc = 0;
    this.subCategoryWithCustomFunds.forEach(value => {
      funds = [...funds, ...value.customFunds];
    });
    funds.forEach(f => {
      percentageAcc += f.userPercentage!;
      compositions.push({
        subCategoryName: f.fund?.title!,
        percentage: f.userPercentage!,
        color: f.color!,
        displayOrder: f.groupCategoryDisplayOrder,
      });
    });
    compositions.push(
      new PortfolioCompositionModel({
        subCategoryName: 'Caja',
        percentage: 1,
        subCategoryId: 1,
        fundingId: 0,
        color: this.colorService.getBlue(0),
      }),
    );
    if (percentageAcc < 99)
      compositions.push(
        new PortfolioCompositionModel({
          subCategoryName: 'No asignado',
          percentage: 100 - 1 - percentageAcc,
          subCategoryId: 1,
          fundingId: -1,
          color: '#eaecef',
        }),
      );
    this.compositionGraphTitle = `
    <div class="flex flex-col">
        <div class="flex flex-col py-2 border-b  px-1">
        <span class="font-semibold">${percentageAcc + 1}% </span>
        <span style="font-size:12px">Asignado </span>

        </div>
        <div class="flex flex-col py-2  px-1">
        <span class="font-semibold">${100 - 1 - percentageAcc}% </span>
        <span style="font-size:12px">No asignado </span>

        </div>
    </div>

    `;
    this.customFunds = funds;
    this.compositionsGraph = compositions;
    let dualNationalPercentages =
      this.goalFundingService.getNationalInternationalCustomFundingPercentage(
        this.customFunds,
        this.financialEntity.uuid === 'bp-us',
      );
    this.groupCategoryPercentages = this.goalFundingService.getCustomFundingStockPercentage(
      this.customFunds,
    );
    this.nationalInternationalPercentages.nationalPercentage = dualNationalPercentages.percentage1;
    this.nationalInternationalPercentages.internationalPercentage =
      dualNationalPercentages.percentage2;
    this.stockBondsPercentages.stockPercentage = this.groupCategoryPercentages.find(
      value => value.groupCategoryUuid === 'stocks',
    )!.percentage;
    this.stockBondsPercentages.bondsPercentage = 100 - this.stockBondsPercentages.stockPercentage;
    this.riskLevel = this.getRiskLevelByEntityCustom(
      this.financialEntity?.currentVersionRiskLevel?.value!,
      this.stockBondsPercentages.stockPercentage,
    )!;
    this.cd.detectChanges();
  }
  onChooseBpStrategy() {
    this.onChooseBpStrategyChange.emit();
  }
  onFormGroupChangeEvent(_event: FormGroup) {
    this.form.push(_event);
    const sum = this.form.value.reduce((accumulator: number, object: any) => {
      return accumulator + object.sum;
    }, 0);
    this.sum = sum;
  }
  onFundsDetailChangeEvent(_event: INewCustomCategoryFund) {
    const index = this.subCategoryWithCustomFunds.findIndex(
      f => f.category.categoryId == _event.category.categoryId,
    );
    this.subCategoryWithCustomFunds[index] = _event;
    this.currentSubCategoryWithCustomFunds[index] = _event;
    // this.onFundsDetailChange.emit(this.subCategoryWithCustomFundsResult.defaultCustomFunds);
    this.getCustomFunds();
  }
  onAcceptPortfolio() {
    this.customPortfolioResult = {
      customCategoryFund: this.subCategoryWithCustomFunds,
      riskLevel: this.riskLevel!,
      stockBondsPercentages: this.stockBondsPercentages,
    };
    this.next.emit(this.customPortfolioResult);
  }
  resetValues() {
    this.form = this.fb.array([]);
    this.subCategoryWithCustomFunds = this.subCategoryWithCustomFunds.map(value => {
      return {
        category: value.category,
        customFunds: value.customFunds.map(f => {
          return {
            userPercentage: f.defaultPercentage,
            defaultPercentage: f.defaultPercentage,
            fund: f.fund,
            color: f.color,
            category: value.category,
            groupCategoryDisplayOrder: f.groupCategoryDisplayOrder,
          };
        }),
      };
    });

    this.currentSubCategoryWithCustomFunds = this.subCategoryWithCustomFunds.map(value => {
      return {
        category: value.category,
        customFunds: value.customFunds.map(f => {
          return {
            userPercentage: f.defaultPercentage,
            defaultPercentage: f.defaultPercentage,
            fund: f.fund,
            color: f.color,
            category: value.category,
            groupCategoryDisplayOrder: f.groupCategoryDisplayOrder,
          };
        }),
      };
    });

    // this.onFundsDetailChange.emit(this.subCategoryWithCustomFundsResult.defaultCustomFunds);
    this.getCustomFunds();
    this.subCategoryWithFundsLength = this.subCategoryWithCustomFunds!.length;
    this.listenChanges();
  }
  private listenChanges() {
    if (this.sumSubscription) {
      this.sumSubscription.unsubscribe();
      setTimeout(() => {
        if (this.form.value.length > 0)
          this.sumValue = this.form.value.reduce((accumulator: number, object: any) => {
            return accumulator + object.sum;
          }, 0);
      });
    }

    this.sumSubscription = this.form.valueChanges.subscribe(value => {
      const sum = value.reduce((accumulator: number, object: any) => {
        return accumulator + object.sum;
      }, 0);
      setTimeout(() => {
        this.sumValue = sum;
      });
    });
  }
  private getRiskLevelByEntityCustom(versionRiskLevel: string, stockPercentage: number) {
    if (this.riskLevels) {
      let riskLevelsFiltered = this.riskLevels.filter(risk => risk.version == versionRiskLevel);
      if (stockPercentage == 0) return riskLevelsFiltered.find(risk => risk.position == 1);
      if (this.between(stockPercentage, 0, 25))
        return riskLevelsFiltered.find(risk => risk.position == 2);
      if (this.between(stockPercentage, 25, 50))
        return riskLevelsFiltered.find(risk => risk.position == 3);
      if (this.between(stockPercentage, 50, 75))
        return riskLevelsFiltered.find(risk => risk.position == 4);
      if (this.between(stockPercentage, 75, 100))
        return riskLevelsFiltered.find(risk => risk.position == 5);
    }
    return undefined;
  }
  private between(x: number, min: number, max: number): boolean {
    return x > min && x <= max;
  }
}
